export enum ModelStatus {
	Published = 'Published',
	Inactive = 'Inactive',
	Deleted = 'Deleted',
	Draft = 'Draft',
	Archived = 'Archived',
}
